// src/components/admin/AdminPanel.js
import React from 'react';
import {
  Box,
  Container,
  Heading,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  useColorModeValue,
} from '@chakra-ui/react';
import Dashboard from './Dashboard';
import ProductManagement from './ProductManagement';

const AdminPanel = () => {
  const bgColor = useColorModeValue('gray.50', 'gray.800');
  const tabBgColor = useColorModeValue('white', 'gray.700');

  return (
    <Container maxW="container.xl" py={10}>
      <Box mb={6}>
        <Heading as="h1" size="xl">管理パネル</Heading>
      </Box>

      <Box bg={bgColor} borderRadius="lg" overflow="hidden">
        <Tabs variant="enclosed" colorScheme="blue">
          <TabList bg={tabBgColor} px={4} pt={4}>
            <Tab 
              _selected={{ 
                bg: 'white', 
                borderColor: 'inherit',
                borderBottomColor: 'transparent'
              }}
            >
              ダッシュボード
            </Tab>
            <Tab 
              _selected={{ 
                bg: 'white', 
                borderColor: 'inherit',
                borderBottomColor: 'transparent'
              }}
            >
              商品管理
            </Tab>
          </TabList>

          <TabPanels bg={tabBgColor}>
            <TabPanel>
              <Dashboard />
            </TabPanel>
            <TabPanel>
              <ProductManagement />
            </TabPanel>
          </TabPanels>
        </Tabs>
      </Box>
    </Container>
  );
};

export default AdminPanel;